<template>
  <div class="dialog-body" v-on:close="onClose">
    <h1>
      Convert BPoints to
      <b class="brand-name-element"></b>
    </h1>

    <div class="info-container">
      <form
        id="convert_form"
        method="POST"
        :action="this.url"
        name="convert-form"
        @submit="submit"
      >
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" id="partner" name="partner">
        <input type="hidden" id="partner_name" name="partnerName">
        <input type="hidden" id="memberUIDNumberInputName" name="memberUIDNumberInputName">
        <input type="hidden" id="conversionRatio" name="conversionRatio" v-model="conversionRatio">
        <input
          type="hidden"
          id="binf_number"
          name="binfNumber"
          :value="selectedCard !== null ? selectedCard.card_no : null"
        >
        <div class="form-group card-selector">
          <label class="required-label">SELECT YOUR B INFINITE CARD</label>
          <div class="dropdown">
            <button
              class="btn btn-secondary dropdown-toggle form-control"
              type="button"
              id="bcardDdMenuBtn"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              aria-describedby="pointsAvailable"
            >
              {{ isSelected ? 'BCard&nbsp;' + selectedCard.card_no : 'Select card' }}
              <span
                class="caret"
                v-if="!isSelected"
              ></span>
              <span class="balance-text" v-if="isSelected">
                Available
                Points
                <span
                  class="pink"
                >{{ formatPoints(selectedCard.lms_BalancePoint) }}</span>
              </span>
            </button>
            <div class="dropdown-menu col-12" aria-labelledby="bcardDdMenuBtn">
              <!-- <a class="dropdown-item readonly">
                <small>Select card</small>
              </a> -->
              <a
                class="dropdown-item"
                v-for="card in this.parseObject"
                :key="card.id"
                :value="card"
                v-on:click="setSelectedCard(card, $event)"
              >
                BCard&nbsp;{{ card.card_no }}
                <span class="balance-text no-caret">
                  Available
                  Points
                  <span
                    class="pink"
                  >{{ formatPoints(card.lms_BalancePoint) }}</span>
                </span>
              </a>
            </div>
          </div>
          <p style="color:red;">
            <span id="pointsAvailable" class="form-text text-muted">
              
              <span
                v-if="isAmountSelected && isSelected && selectedCard.lms_BalancePoint < selectedAmountPackage.points_required"
                style="color: red;"
              >Insufficient BPoints balance</span>
            </span>
          </p>
        </div>
        
        
        <div class="form-group">
          <label class="required-label">B Infinite Card PIN</label>
          <input
            class="form-control col-md-5"
            type="password"
            id="bcard_pin"
            placeholder="Your PIN for authorization"
            name="bcardPIN"
            v-model="bcardPIN"
            :readonly="isSubmitting"
            required
            oninvalid="this.setCustomValidity('Please fill in the required field')"
            oninput="this.setCustomValidity('')"
          >
        </div>
        <div class="form-group card-selector">
          <label class="required-label">SELECT YOUR AMOUNT</label>
          <div class="dropdown">
            <button
              class="btn btn-secondary dropdown-toggle form-control"
              type="button"
              id="amountDdMenuBtn"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              aria-describedby="amountAvailable"
            >
              {{ isAmountSelected ? selectedAmountPackage.title : 'Select amount' }}
              <span
                class="caret"              ></span>
             
            </button>
            <div class="dropdown-menu col-12" aria-labelledby="bcardDdMenuBtn">
              <!-- <a class="dropdown-item readonly">
                <small>Select card</small>
              </a> -->
              <a
                class="dropdown-item"
                v-for="amountPackage in this.amountPackages"
                :key="amountPackage.id"
                :value="amountPackage"
                v-on:click="setSelectedAmount(amountPackage, $event)"
              >
                {{ amountPackage.title }}
                
              </a>
            </div>
          </div>
           <span id="pointsAvailable" class="form-text text-muted"
              v-if="!errors['bpointsAmount'] && isAmountSelected && pointsConvertAmount > 0">
          <span>{{ formatPoints(pointsConvertAmount) }} BPOINTS NEEDED TO CONVERT</span>
          </span>
          
        </div>
         <div class="form-group"  v-if="platform=='umobile'">
          <label class="required-label">Recipient's No</label>
          <input
            class="form-control col-md-5"
            type="text"
            id="MSISDN"
            placeholder="Enter Recipient's No (Eg. 60181234567)"
            name="MSISDN"
            v-model="MSISDN"
            :readonly="isSubmitting"
            oninvalid="this.setCustomValidity('Please fill in the required field')"
            oninput="this.setCustomValidity('')"
          >
        </div>
        
        <div style="margin-top: 15px"></div>
   
        <input type="hidden"
            id="amountSelected_id"
            name="amountSelected_id"
            v-model="amountSelected_id"
            >
         <input type="hidden"
            id="package_id"
            name="package_id"
            v-model="package_id"
            >
        <input type="hidden"
            id="block_point"
            name="blockPoints"
            v-model="blockPoints"
            >
        <input type="hidden"
            id="amount_index"
            name="amount_index"
            v-model="amount_index"
            >
        
        <div v-if="errorMessage != ''" class>{{ errorMessage }}</div>
        <button
          id="convert_points_button"
          type="submit"
          class="btn btn-blue"
          :disabled="!isCanSubmit"
        >CONTINUE TO CONVERT</button>
      </form>
    </div>
  </div>
</template>

<script>
var data = {
      csrf: null,
      selectedCard: null,
      selectedAmountPackage:null,
      bcardPIN: "",
      memberUidNumber: "",
      bpointsAmount: 0,
      isSelected: false,
      isAmountSelected: false,
      amountSelected_id: false,
      isSubmitting: false,
      errorMessage: "",
      conversionRatio: 1,
      blockPoints: 100,
      amountPackages:[],
      package_id:null,
      amount_index:0,
      pointsConvertAmount:0,
      platform:'',
      MSISDN:'',
      errors: {},
    };
// Terribly sorry for this hack.. Gotta make sure this stuff is done
// Gives ability to change the vue data from front
window.prepaidTopupDialogData = data;
export default {
  // Note: data-cards, data-f-name and data-l-name becomes camel case in props
  props: [
    "dataCards",
    "dataFName",
    "dataLName",
    "dataMobile",
    "dataEmail",
  ],

  data() {
    var csrfElement = document
        .querySelector('meta[name="csrf-token"]')
    if (csrfElement.getAttribute("content")) {
      data['csrf'] = csrfElement.getAttribute("content");
    }
    data['url'] = this.$routes["prepaid_topup"];
    data['cards'] = this.dataCards;
    data['bcardFName'] = this.dataFName;
    data['bcardLName'] = this.dataLName;
    data['mobileNumber'] = this.dataMobile;
    data['email'] = this.dataEmail;
    return data;
  },
  methods: {

    setSelectedCard: function(card, e) {
      e.preventDefault();

      this.selectedCard = card;
      this.isSelected = this.selectedCard !== null;

      this.brandName = document.getElementById("partner_name").value;
      this.validatePoints();
    },
    setSelectedAmount: function(amountPackage, e) {
      e.preventDefault();

      this.selectedAmountPackage = amountPackage;
      this.isAmountSelected = this.selectedAmountPackage !== null;
      this.amountSelected_id=amountPackage.id;
      this.amount_index=amountPackage.index;
      this.pointsConvertAmount=amountPackage.points_required;
      this.validatePoints();
    },


    formatPoints: function(value) {
//      let val = (value * conversionRatio).toFixed(0);
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    calcConvertablePoints: function() {
      return this.formatPoints(this.maxConvertedAmount);
    },

    onClose: function() {
      this.selectedCard = null;
      this.isSelected = false;
    },

    validatePoints: function() {
      if (this.selectedCard && this.selectedAmountPackage) {
        this.$delete(this.errors, 'bpointsAmount');
        // Must be sufficient
        if (parseInt(this.selectedCard.lms_BalancePoint) < this.selectedAmountPackage.points_required) {
          this.$set(this.errors, 'bpointsAmount', `Insufficient BPoints balance`);
          return;
        }
        
//        if(this.platform=='umobile' && this.MSISDN ==''){
//             this.$set(this.errors, 'MSISDN', `Please fill in required field`);
//            return;
//        }

      

      }

      return 0;
    },

    submit: function(e) {
      this.validatePoints();
      if (_.isEmpty(this.errors)) {
        this.isSubmitting = true;
      } else {
        e.preventDefault();
      }
    }
  },
  computed: {
    parseObject: function() {
      return JSON.parse(this.dataCards);
    },



    isCanSubmit: function() {
       

      return !this.isSubmitting &&
        this.selectedCard != null &&
        this.selectedAmountPackage != null &&
        _.isEmpty(this.errors);
    },

   
    // },
    // mounted() {
    //   // vm.$forceUpdate();
    //   // console.log(this.parseObject);
  }
};
</script>
